import React from "react";
import { Button } from "components/button";
import { EstimateBindingCard } from "components/EstimateBindingCard";
import "./EstimateBinding.scss"
import { FormGroup, Validators, FormBuilder, FormControl } from "react-reactive-form";
import { isMobile } from "core/utils";

export interface EstimateBindingProps {
    onClick?(): void;
    formControl?: FormControl;
}
 
export interface EstimateBindingState {
    
}
 
class EstimateBinding extends React.Component<EstimateBindingProps, EstimateBindingState> {
    constructor(props: EstimateBindingProps) {
        super(props);
        this.state = {  };
    }
    getSignature() {
//debugger;
        // var isAffirm=(localStorage.getItem("isAffirm") || "0");
        // if(this.props.formControl){
        //     if(isAffirm=="1"){
        //         this.props.formControl.setValue("1")
        //     }else{
        //         this.props.formControl.setValue("0")
        //     }
        // }

        if (this.props.onClick) {
            this.props.onClick()
            
        }
    }
    render() { 
        return ( 
            <div className="todo-container">
                <div className={"paperContainer"} style={{height:window.innerHeight-150}}>
                <div className="gap short" />
                    <div className="paperworkEst-title">
                        {/* {
                        isSuper ? <h1>Your Super deal move Details</h1>
                            : <h1>Your  Move Details</h1>
                    } */}
                        <h1> Estimate Type:Binding</h1>
                    </div>
             <EstimateBindingCard/> 
             </div>
             <div style={{width:"100%"}}>
        <Button
                text={"Continue"}
                onClick={() => this.getSignature()}
            />
            </div>
            </div>
         );
    }
}
 
export default EstimateBinding;